export { DiningReservationTemplate } from './DiningReservationTemplate';
export type {
  DiningReservationLabels,
  DiningReservationMenuLink,
  DiningReservationRestaurant,
  DiningReservationTemplateProps,
} from './DiningReservationTemplate.types';
